import React, { useEffect } from 'react'
import Slider from './Components/HeroSection/Slider'
import Todatoffersbaner from './Components/TodayOffers/Todatoffersbaner'
import Todayoffers from './Components/TodayOffers/TodayOffers'
import ImagesCoupons from './Components/Coupons/ImagesCoupons'
import SeasonalOffers from './Components/SeasonalOffers/SeasonalOffers'
import Mail from './Components/Mail'
import PickyourProducts from './Components/PickyourProducts'
import MainTopBrands from './Components/TopBrands/MainTopBrands'
import TrendingStores from './Components/TrendingStores/TrendingStores'
import ProductsLaunching from './Components/ProductsLaunching/ProductsLaunching'
import PremiumCouponsBanner from './Components/PremiumCoupons/PremiumCouponsBanner'
import PremiumCoupons from './Components/PremiumCoupons/PremiumCoupons'
import axios from 'axios'
import Visitors from './Components/Visitors'

const Home = () => {
  const payload =
  {
    visitDate: new Date(),
    visitorCount: 0
  }
  useEffect(() => {
    axios.post('https://api.bakpoket.com/api/Admin/add-visitorcount',payload)
      .then(res => console.log(res))
      .catch(err => console.log(err))
  }, [])
  return (
    <div>
      <update-meta-data
        stitle="Grab the Best Free Coupons and Deals Online – Save Big Today! – bakpoket "
        sdescription="Discover the latest free coupons, exclusive promo codes, and unbeatable online deals. Start saving instantly on your favorite brands and stores! – bakpoket"
        scanonical="https://bakpoket.com/"
        class="ng-scope">
      </update-meta-data>

      <Slider />
      <Todatoffersbaner />
      <Todayoffers />
      <ImagesCoupons />
      <PremiumCouponsBanner />
      <PremiumCoupons />
      <PickyourProducts />
      <MainTopBrands />
      <TrendingStores />
      <ProductsLaunching />
      <SeasonalOffers />
      <Mail />
      <Visitors/>
    </div>
  )
}

export default Home
